<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">{{ topTitle }}</div>
      <div class="title--button">
        <el-button type="primary" size="small" plain @click="goOverview">
          库存总览
        </el-button>
        <el-button type="primary" size="small" plain @click="goSummary">
          库存汇总
        </el-button>
        <el-button type="primary" size="small" plain @click="goFlow()">
          库存流水
        </el-button>
        <el-button type="primary" size="small" plain @click="goBatchInventory">
          批次台账
        </el-button>
        <myExportExcel
          :excelTitleList="titleList"
          :idsList="exportIdsList"
          :url="OUTSOURCING_EXPORT_URL.WAREHOUSE"
          :filter="searchData"
          :excelName="'委外协同库存'"
        />
        <printViewBtn
          :changeList="printChangeList"
          :modules="OUTSOURCING_PRINT_MODULES.WAREHOUSE"
          :printFun="outsourcingWarehouse_view"
          :allowLabelPrint="true"
        />
      </div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="searchData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
      <template slot="outsourcingDocNumber">
        <el-popover placement="bottom" trigger="click">
          <vxe-table
            :data="orderList"
            style="width: 100%"
            border
            max-height="400"
            @cell-click="orderRowClick"
          >
            <vxe-column align="center" title="类型" width="90">
              <template slot-scope="{ row }">
                <div>{{ row._bizDocKindLabel }}</div>
              </template>
            </vxe-column>
            <vxe-column align="center" title="委外单号" width="150">
              <template slot-scope="{ row }">
                <div>{{ row.outsourcingDocNumber }}</div>
              </template>
            </vxe-column>
            <vxe-column align="center" title="物料/产品名称" min-width="140">
              <template slot-scope="{ row }">
                <div>{{ row.baseMaterialName || "--" }}</div>
              </template>
            </vxe-column>
          </vxe-table>
          <el-pagination
            :total="orderListQuery.total"
            :page-size="orderListQuery.pageSize"
            :current-page="orderListQuery.pageNum"
            layout="prev, pager, next"
            @current-change="(page) => orderGetList(page, searchData.outsourcingDocNumber)"
            style="margin-top: 12px; text-align: right"
          />
          <el-input
            size="small"
            style="width: 180px; margin-right: 10px"
            placeholder="选择委外单"
            v-model="searchData.outsourcingDocNumber"
            clearable
            @input="orderGetList(1, searchData.outsourcingDocNumber)"
            @click.native="orderGetList(1, searchData.outsourcingDocNumber || '')"
            @clear="clearOrderFilter"
            slot="reference"
          />
        </el-popover>
      </template>
    </my-operate>
    <myHtml
      style="margin-top: 10px"
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :keyData="keyData"
      :checkKey="mergeGroupKey"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      ref="myTable"
    />
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
  </div>
</template>

<script>
import {
  outsourcingWarehouse_list,
  outsourcingWarehouse_view,
  outsourcingDoc_vagueList,
  processOutsourcing_list,
} from "@/api/myController/outsourcing";
import { _debounce } from "@/utils/myUtils";
import {
  OUTSOURCING_PRINT_MODULES,
  buildPrintChangeList,
} from "@/utils/outsourcingPrint";
import {
  OUTSOURCING_EXPORT_URL,
  buildExportIdsList,
} from "@/utils/outsourcingExport";
import {
  WAREHOUSE_BIZ_DOC_KIND,
  WAREHOUSE_BIZ_DOC_KIND_OPTIONS,
  WAREHOUSE_MATERIAL_STATUS_OPTIONS,
  getWarehouseBizDocKindLabel,
  parseWarehouseSpec,
  buildWarehouseListPayload,
} from "@/utils/outsourcingWarehouse";

const DOC_MERGE_FIELDS = ["bizDocKind", "baseOutsourcingDocId"];

export default {
  name: "cooperative_outsourcing_warehouse",
  data() {
    return {
      topTitle: "协同库存仓",
      OUTSOURCING_PRINT_MODULES,
      OUTSOURCING_EXPORT_URL,
      outsourcingWarehouse_view,
      listLoading: false,
      columnType: "columnAll",
      tableBtnList: ["流水"],
      list: [],
      changeList: [],
      mergeGroupKey: "_docMergeKey",
      keyData: ["_docMergeKey", "_materialMergeKey"],
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        baseOutsourcingDocId: null,
      },
      searchData: {
        outsourcingDocNumber: "",
        baseMaterialNumber: "",
        baseMaterialName: "",
        productionOrMaterial: "",
        bizDocKind: null,
        searchString: "",
        baseMaterialId: null,
        baseSpecGroupId: null,
      },
      orderList: [],
      orderListQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
      },
      orderInitQuery: null,
      operationTitleData: [
        {
          name: "物料编号",
          value: "baseMaterialNumber",
          type: "text",
        },
        {
          name: "物料名称",
          value: "baseMaterialName",
          type: "text",
        },
      ],
      titleOperationTitleData: [
        {
          name: "业务类型",
          value: "bizDocKind",
          type: "buttonList",
          btnList: [
            { name: "全部", value: null },
            { name: "产品委外", value: WAREHOUSE_BIZ_DOC_KIND.PRODUCT },
            { name: "工序委外", value: WAREHOUSE_BIZ_DOC_KIND.PROCESS },
          ],
        },
        { name: "", type: "line" },
        { name: "综合搜索", value: "searchString", type: "text" },
        { name: "搜索", type: "button" },
        { name: "重置", type: "button" },
      ],
      titleList: [
        {
          id: 1,
          name: "业务类型",
          value: "bizDocKind",
          key: "_docMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: WAREHOUSE_BIZ_DOC_KIND_OPTIONS,
          canEdit: false,
          width: 100,
          sort: 5,
        },
        {
          id: 2,
          name: "委外单编号",
          value: "outsourcingDocNumber",
          key: "_docMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
          sort: 10,
        },
        {
          id: 3,
          name: "物料编号",
          value: "baseMaterialNumber",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          color: "#409eff",
          width: 120,
          sort: 20,
        },
        {
          id: 4,
          name: "物料名称",
          value: "baseMaterialName",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 140,
          sort: 30,
        },
        {
          id: 5,
          name: "库存数量",
          value: "valueMaterialQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 100,
          sort: 40,
        },
        {
          id: 6,
          name: "规格",
          value: "materialSpecList",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 160,
          sort: 50,
        },
        {
          id: 7,
          name: "客户料号",
          value: "baseCustomerMaterialNumber",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sort: 60,
        },
        {
          id: 8,
          name: "单位",
          value: "baseMaterialUnitName",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 80,
          sort: 70,
        },
        {
          id: 9,
          name: "产品类型",
          value: "baseMaterialTypeName",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 100,
          sort: 80,
        },
        {
          id: 10,
          name: "批次号",
          value: "batchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sort: 90,
        },
        {
          id: 11,
          name: "物料状态",
          value: "productionOrMaterial",
          key: "_materialMergeKey",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: WAREHOUSE_MATERIAL_STATUS_OPTIONS,
          canEdit: false,
          width: 110,
          sort: 100,
        },
        {
          id: 12,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 150,
          sort: 110,
        },
        {
          id: 13,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 140,
          sort: 120,
        },
      ],
    };
  },
  computed: {
    printChangeList() {
      return buildPrintChangeList(this.changeList, "outsourcingWarehouseId");
    },
    exportIdsList() {
      return buildExportIdsList(this.changeList, "outsourcingWarehouseId");
    },
  },
  created() {
    this.orderInitQuery = _debounce((page, value) => {
      this.orderListQuery.pageNum = page || 1;
      this.loadOrderCandidates(value || "");
    }, 300);

    const query = this.$route.query || {};
    if (
      query.bizDocKind !== undefined &&
      query.bizDocKind !== null &&
      query.bizDocKind !== ""
    ) {
      this.searchData.bizDocKind = Number(query.bizDocKind);
    }
    if (
      query.outsourcingDocId ||
      query.baseOutsourcingDocId ||
      query.processOutsourcingDocId
    ) {
      this.listQuery.baseOutsourcingDocId =
        query.processOutsourcingDocId ||
        query.outsourcingDocId ||
        query.baseOutsourcingDocId;
      this.searchData.outsourcingDocNumber =
        query.processOutsourcingDocNumber ||
        query.outsourcingDocNumber ||
        query.baseOutsourcingDocNumber ||
        "";
      if (
        query.processOutsourcingDocId &&
        (this.searchData.bizDocKind === "" ||
          this.searchData.bizDocKind === null ||
          this.searchData.bizDocKind === undefined)
      ) {
        this.searchData.bizDocKind = WAREHOUSE_BIZ_DOC_KIND.PROCESS;
      }
    }
    this.getList();
  },
  methods: {
    buildMergeKey(item, fields) {
      return fields
        .map((field) => {
          const value = item[field];
          return value == null ? "" : String(value);
        })
        .join("||");
    },
    getList() {
      this.listLoading = true;
      outsourcingWarehouse_list(
        buildWarehouseListPayload({
          baseOutsourcingDocId: this.listQuery.baseOutsourcingDocId,
          searchData: this.searchData,
          pageParam: {
            pageNum: this.listQuery.pageNum,
            pageSize: this.listQuery.pageSize,
          },
          orderParam: [],
        })
      )
        .then((res) => {
          const pageData = res.data.data || {};
          const dataList = (pageData.dataList || []).map((item, index) => {
            const row = parseWarehouseSpec(item);
            row._docMergeKey = this.buildMergeKey(row, DOC_MERGE_FIELDS);
            row._materialMergeKey = [
              row._docMergeKey,
              row.baseMaterialId == null ? "" : String(row.baseMaterialId),
              row.baseSpecGroupId || row.baseSpecgroupId || "",
            ].join("||");
            row._originIndex = index;
            return row;
          });
          dataList.sort((a, b) => {
            const docCompare = a._docMergeKey.localeCompare(b._docMergeKey);
            if (docCompare !== 0) return docCompare;
            const materialCompare = a._materialMergeKey.localeCompare(
              b._materialMergeKey
            );
            if (materialCompare !== 0) return materialCompare;
            return a._originIndex - b._originIndex;
          });
          this.list = dataList;
          this.listQuery.total = pageData.totalCount || 0;
        })
        .catch(() => {
          this.list = [];
          this.listQuery.total = 0;
        })
        .finally(() => {
          this.listLoading = false;
          this.$refs.myOperate?.dragSortShow();
        });
    },
    loadOrderCandidates(value) {
      const kind = this.searchData.bizDocKind;
      const pageParam = {
        pageNum: this.orderListQuery.pageNum,
        pageSize: this.orderListQuery.pageSize,
      };
      const orderParam = [{ asc: false, fieldName: "createTime" }];
      const loadProduct = () =>
        outsourcingDoc_vagueList({
          outsourcingDocFilter: { searchString: value || "" },
          orderParam,
          pageParam,
        }).then((res) => {
          const pageData = res.data.data || {};
          return {
            list: (pageData.dataList || []).map((row) => ({
              ...row,
              _bizDocKind: WAREHOUSE_BIZ_DOC_KIND.PRODUCT,
              _bizDocKindLabel: getWarehouseBizDocKindLabel(
                WAREHOUSE_BIZ_DOC_KIND.PRODUCT
              ),
              outsourcingDocNumber: row.outsourcingDocNumber,
              baseOutsourcingDocId: row.outsourcingDocId || row.baseOutsourcingDocId,
            })),
            total: pageData.totalCount || 0,
          };
        });
      const loadProcess = () =>
        processOutsourcing_list({
          processOutsourcingDtoFilter: { searchString: value || "" },
          orderParam,
          pageParam,
        }).then((res) => {
          const pageData = res.data.data || {};
          return {
            list: (pageData.dataList || []).map((row) => ({
              ...row,
              _bizDocKind: WAREHOUSE_BIZ_DOC_KIND.PROCESS,
              _bizDocKindLabel: getWarehouseBizDocKindLabel(
                WAREHOUSE_BIZ_DOC_KIND.PROCESS
              ),
              outsourcingDocNumber: row.processOutsourcingDocNumber,
              baseOutsourcingDocId: row.processOutsourcingDocId,
              processOutsourcingDocId: row.processOutsourcingDocId,
            })),
            total: pageData.totalCount || 0,
          };
        });

      let request;
      if (Number(kind) === WAREHOUSE_BIZ_DOC_KIND.PRODUCT) {
        request = loadProduct();
      } else if (Number(kind) === WAREHOUSE_BIZ_DOC_KIND.PROCESS) {
        request = loadProcess();
      } else {
        request = Promise.all([
          loadProduct().catch(() => ({ list: [], total: 0 })),
          loadProcess().catch(() => ({ list: [], total: 0 })),
        ]).then(([product, process]) => ({
          list: [...product.list, ...process.list],
          total: (product.total || 0) + (process.total || 0),
        }));
      }

      request
        .then((result) => {
          this.orderList = result.list || [];
          this.orderListQuery.total = result.total || 0;
        })
        .catch(() => {
          this.orderList = [];
          this.orderListQuery.total = 0;
        });
    },
    orderGetList(page, value) {
      this.orderList = [];
      if (this.orderInitQuery) {
        this.orderInitQuery(page, value);
      }
    },
    orderRowClick({ row }) {
      this.listQuery.baseOutsourcingDocId =
        row.processOutsourcingDocId ||
        row.outsourcingDocId ||
        row.baseOutsourcingDocId;
      this.searchData.outsourcingDocNumber =
        row.processOutsourcingDocNumber || row.outsourcingDocNumber || "";
      if (row._bizDocKind !== undefined && row._bizDocKind !== null) {
        this.searchData.bizDocKind = row._bizDocKind;
      }
      this.listQuery.pageNum = 1;
      this.getList();
      document.body.click();
    },
    clearOrderFilter() {
      this.listQuery.baseOutsourcingDocId = null;
      this.searchData.outsourcingDocNumber = "";
      this.listQuery.pageNum = 1;
      this.getList();
    },
    titleOperationBtnClick(item) {
      switch (item.name) {
        case "搜索":
          this.listQuery.pageNum = 1;
          this.getList();
          break;
        case "重置":
          this.listQuery.baseOutsourcingDocId = null;
          this.searchData = {
            outsourcingDocNumber: "",
            baseMaterialNumber: "",
            baseMaterialName: "",
            productionOrMaterial: "",
            bizDocKind: null,
            searchString: "",
            baseMaterialId: null,
            baseSpecGroupId: null,
          };
          this.listQuery.pageNum = 1;
          this.getList();
          break;
        case "全部":
        case "产品委外":
        case "工序委外":
          this.listQuery.pageNum = 1;
          this.getList();
          break;
        default:
          break;
      }
    },
    operationBtnClick(item) {
      this.titleOperationBtnClick(item);
    },
    btnClick(row, item) {
      if (item === "流水") {
        this.goFlow(row);
      }
    },
    goOverview() {
      this.$router.push({ name: "outsourcingProduct_warehouseOverview" });
    },
    goSummary() {
      this.$router.push({ name: "outsourcingProduct_warehouseSummary" });
    },
    goFlow(row) {
      const query = {};
      if (row && row.outsourcingWarehouseId) {
        query.outsourcingWarehouseId = row.outsourcingWarehouseId;
        if (row.baseMaterialNumber) {
          query.baseMaterialNumber = row.baseMaterialNumber;
        }
        if (row.baseMaterialName) {
          query.baseMaterialName = row.baseMaterialName;
        }
        if (row.batchNumber) {
          query.batchNumber = row.batchNumber;
        }
      }
      this.$router.push({
        name: "outsourcingProduct_warehouseFlow",
        query,
      });
    },
    goBatchInventory() {
      this.$router.push({
        name: "outsourcingProduct_warehouseBatchInventory",
      });
    },
    cellClickEvent() {},
    selectChangeEvent(val) {
      this.changeList = val.records || [];
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records || [];
    },
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value === val.field && item.name === val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    onStart() {},
    onEnd(titleList) {
      this.titleList = titleList;
    },
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    widthClick(titleList) {
      this.titleList = titleList;
    },
    resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title--font {
  text-align: left;
  padding: 10px 0;
}

.title--button {
  position: absolute;
  right: 0;
  margin-top: 0.7%;
}

::v-deep .operation {
  margin-bottom: 10px;
}

::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  box-sizing: border-box;
}

::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}

::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}

::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}

::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}

::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
</style>
